import { FC, useContext } from 'react';
import { ProductsContext } from 'contexts/products';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const ProductsLoader: FC = () => {
  const { productsLoading } = useContext(ProductsContext);

  if (!productsLoading) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      sx={
        {
          position: 'absolute',
          width: '100%',
          height: '100%',
          zIndex: 20,
          background: YodaColors.white,
          opacity: 0.5,
        }
      }
    >
      <Loader center />
    </Box>
  );
};

export default ProductsLoader;
